export const Colors = {
  amber: { name: 'Amber', hex: 'f59e0b', color: 'amber-500', fill: 'fill-amber-500' },
  blue: { name: 'Blue', hex: '3b82f6', color: 'blue-500', fill: 'fill-blue-500' },
  cyan: { name: 'Cyan', hex: '06b6d4', color: 'cyan-500', fill: 'fill-cyan-500' },
  emerald: { name: 'Emerald', hex: '10b981', color: 'emerald-500', fill: 'fill-emerald-500' },
  fuchsia: { name: 'Fuchsia', hex: 'e879f9', color: 'fuchsia-500', fill: 'fill-fuchsia-500' },
  green: { name: 'Green', hex: '22c55e', color: 'green-500', fill: 'fill-green-500' },
  lime: { name: 'Lime', hex: '84cc16', color: 'lime-500', fill: 'fill-lime-500' },
  orange: { name: 'Orange', hex: 'f97316', color: 'orange-500', fill: 'fill-orange-500' },
  red: { name: 'Red', hex: 'ef4444', color: 'red-500', fill: 'fill-red-500' },
  slate: { name: 'Slate', hex: '64748b', color: 'slate-500', fill: 'fill-slate-500' },
  violet: { name: 'Violet', hex: '8b5cf6', color: 'violet-500', fill: 'fill-violet-500' },
  black: {
    name: 'Black',
    hex: '000000',
    color: 'black',
    fill: 'fill-black',
    text: 'text-black',
    bg: 'bg-black',
  },
  white: {
    name: 'White',
    hex: 'ffffff',
    color: 'white',
    fill: 'fill-white',
    text: 'text-white',
    bg: 'bg-white',
  },
  gray50: {
    name: 'Gray 50',
    hex: 'f9fafb',
    color: 'gray-50',
    fill: 'fill-gray-50',
    text: 'text-gray-50',
    bg: 'bg-gray-50',
  },
  gray100: {
    name: 'Gray 100',
    hex: 'f3f4f6',
    color: 'gray-100',
    fill: 'fill-gray-100',
    text: 'text-gray-100',
    bg: 'bg-gray-100',
    hoverBg: 'hover:bg-gray-100',
  },
  gray200: {
    name: 'Gray 200',
    hex: 'e5e7eb',
    color: 'gray-200',
    fill: 'fill-gray-200',
    text: 'text-gray-200',
    bg: 'bg-gray-200',
  },
  gray500: {
    name: 'Gray 500',
    hex: '6b7280',
    color: 'gray-500',
    fill: 'fill-gray-500',
    text: 'text-gray-500',
    bg: 'bg-gray-500',
  },
  gray600: {
    name: 'Gray 600',
    hex: '4b5563',
    color: 'gray-600',
    fill: 'fill-gray-600',
    text: 'text-gray-600',
    bg: 'bg-gray-600',
  },
} as const;
